export default function SuccessMsgTemplate(data) {
    //language=HTML
    return `
        <section class="window-save position-fixed">
            <div class="animate__animated animate__fadeInDown">
                <div class="row justify-content-between align-items-center bg-success text-white m-0 px-4 py-3">
                    <span id="title" class="fa-1-5x">${data.title}</span>
                    <span class="fa-1-5x">${data.Msg}</span>
                    <a role="button" class="btn-close-save"><i class="fa-solid fa-xmark fa-1-5x"></i></a>
                </div>
            </div>
        </section>`;
}